module.exports = __webpack_public_path__ + "img/news_nav.f36056ef.png";